export interface TblDmTagCategory {
  id: string;
  categoryName: string;
  type: string | null;
  allowMultiple: boolean;
  status: string | null;
  description: string | null;
  tagCount: number;
  activeTagCount: number;
  createBy?: string | null;
  createDate?: string | null;
  lastUpdateBy?: string | null;
  lastUpdateDate?: string | null;
}

export interface TblDmTag {
  id: string;
  categoryId: string | null;
  categoryName: string | null;
  categoryType: string | null;
  allowMultiple: boolean;
  tagName: string;
  color: string | null;
  status: string | null;
  description: string | null;
  createBy?: string | null;
  createDate?: string | null;
  lastUpdateBy?: string | null;
  lastUpdateDate?: string | null;
}

export interface TagObjectType {
  code: string;
  name: string;
}

/** Trạng thái dùng chung cho danh mục và tag */
export const TAG_STATUS = {
  active: "A",
  inactive: "I",
};

/** Giá trị mặc định khi API get-object-types chưa trả về */
export const TAG_OBJECT_TYPES: TagObjectType[] = [
  { code: "ORDER", name: "Đơn hàng" },
  { code: "CUSTOMER", name: "Khách hàng" },
  { code: "ITEM", name: "Sản phẩm" },
  { code: "WARRANTY", name: "Phiếu bảo hành" },
];

/** Màu chấm của badge đối tượng áp dụng */
export const TAG_OBJECT_TYPE_COLORS: Record<string, string> = {
  ORDER: "blue",
  CUSTOMER: "grape",
  ITEM: "orange",
  WARRANTY: "teal",
};

/** Màu hiển thị của tag (tên màu Mantine) */
export const TAG_COLORS: { value: string; label: string }[] = [
  { value: "blue", label: "Xanh dương" },
  { value: "grape", label: "Tím" },
  { value: "teal", label: "Xanh ngọc" },
  { value: "orange", label: "Cam" },
  { value: "red", label: "Đỏ" },
  { value: "gray", label: "Xám" },
];

export const TAG_API = {
  objectTypes: "/api/v1/TblDmTag/get-object-types",
  listCategory: "/api/v1/TblDmTag/get-list-category",
  createCategory: "/api/v1/TblDmTag/create-category",
  updateCategory: "/api/v1/TblDmTag/update-category",
  deleteCategory: "/api/v1/TblDmTag/delete-category",
  updateCategoryStatus: "/api/v1/TblDmTag/update-category-status",
  listTag: "/api/v1/TblDmTag/get-list-tag",
  createTag: "/api/v1/TblDmTag/create-tag",
  createTags: "/api/v1/TblDmTag/create-tags",
  updateTag: "/api/v1/TblDmTag/update-tag",
  deleteTag: "/api/v1/TblDmTag/delete-tag",
  updateTagStatus: "/api/v1/TblDmTag/update-tag-status",
  assignOrderTags: "/api/v1/TblDmTag/assign-order-tags",
  getOrderTags: "/api/v1/TblDmTag/get-order-tags",
  getOrderTagsByOrders: "/api/v1/TblDmTag/get-order-tags-by-orders",
};

/** Tag đang gắn với 1 đơn hàng */
export interface OrderTag {
  id: string;
  tagName: string;
  categoryId: string;
  categoryName: string | null;
  color: string | null;
  status: string | null;
}

export interface OrderTags {
  orderId: number;
  tags: OrderTag[];
}

/** Đọc danh sách phân trang (IPagedList) trả về từ API POS */
export const readPagedList = <T>(data: any): { list: T[]; total: number } => {
  const list: T[] = data?.lists ?? [];
  const total: number = data?.count ?? data?.totalCount ?? list.length;
  return { list, total };
};
